<template>
  <transition name="slide-up">
    <div v-if="visible" class="install-banner android-style">
      <div class="content">
        <img
          src="/img/icons/android-chrome-192x192.png"
          alt="App Icon"
          class="app-icon"
        />
        <div class="text">
          <strong>Nainstaluj si Prasotipovačku</strong>
          <p>Pro lepší zážitek přímo z plochy.</p>
        </div>
      </div>
      <div class="actions">
        <button @click="dismiss" class="btn-cancel">Ignorovat</button>
        <button @click="install" class="btn-install">INSTALOVAT</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "InstallPwaAlert",
  data() {
    return {
      visible: false,
      deferredPrompt: null, // Zde si schováme povolení od Androidu
    };
  },
  mounted() {
    // 1. Zkontrolujeme, jestli už není nainstalováno
    if (
      localStorage.getItem("pwa_installed") ||
      window.matchMedia("(display-mode: standalone)").matches
    ) {
      return;
    }

    // 2. Chytáme signál od Androidu k instalaci
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      this.deferredPrompt = e; // Schováme si ho na později
      this.checkAndShowBanner(); // Provedeme časovou kontrolu
    });

    // 3. MAGIE PRO OTEVŘENÉ ZÁLOŽKY: Nasloucháme "probuzení" aplikace
    document.addEventListener("visibilitychange", () => {
      // Pokud se uživatel právě vrátil na naši záložku
      if (document.visibilityState === "visible") {
        this.checkAndShowBanner();
      }
    });

    // 4. Nasloucháme na úspěšnou instalaci
    window.addEventListener("appinstalled", () => {
      this.visible = false;
      localStorage.setItem("pwa_installed", "true");
    });
  },
  methods: {
    // Tato funkce zkontroluje čas a případně banner zobrazí
    checkAndShowBanner() {
      // Pokud nemáme signál od Androidu, nebo už banner svítí, nic neděláme
      if (!this.deferredPrompt || this.visible) return;

      const dismissedAt = localStorage.getItem("pwa_prompt_dismissed_at");
      if (dismissedAt) {
        const timePassed = Date.now() - parseInt(dismissedAt);
        const hoursToWait = 24 * 60 * 60 * 1000; // 24 hodin v milisekundách

        // Pokud ještě neuběhlo 24 hodin, zastavíme to
        if (timePassed < hoursToWait) {
          return;
        }
      }

      // Pokud jsme tady, čas vypršel (nebo to ještě nikdy neodmítl). Ukážeme banner!
      this.visible = true;
    },

    dismiss() {
      this.visible = false;
      // Uložíme přesný čas, kdy uživatel kliknul na Ignorovat
      localStorage.setItem("pwa_prompt_dismissed_at", Date.now().toString());
    },

    async install() {
      if (!this.deferredPrompt) return;

      // Spustíme Android instalaci
      this.deferredPrompt.prompt();
      const { outcome } = await this.deferredPrompt.userChoice;

      if (outcome === "accepted") {
        localStorage.setItem("pwa_installed", "true");
      }

      this.deferredPrompt = null;
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.install-banner {
  position: fixed;
  z-index: 10000;
  left: 20px;
  right: 20px;
  background: #111;
  border: 1px solid #dc3545;
  border-radius: 12px;
  padding: 15px;
  color: white;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.9);
  font-family: sans-serif;
}

.content {
  display: flex;
  align-items: center;
  gap: 15px;
}

.app-icon {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  object-fit: cover;
}

.text strong {
  display: block;
  font-size: 1rem;
  margin-bottom: 2px;
  color: #fff;
}
.text p {
  font-size: 0.85rem;
  color: #ccc;
  margin: 0;
  line-height: 1.3;
}

.android-style {
  bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn-install {
  background: #dc3545;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 20px;
  font-weight: bold;
  font-size: 0.9rem;
  cursor: pointer;
}

.btn-cancel {
  background: transparent;
  color: #888;
  border: none;
  font-size: 0.9rem;
  cursor: pointer;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.5s ease;
}
.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(150px);
  opacity: 0;
}
</style>
